import React, { useState, useEffect } from 'react'
import SimpleModal from '../../../components/Modal/SimpleModal'
import { Row, Col, Button, Form, Input, Select, Upload, } from 'antd'

import { useSelector } from 'react-redux'
import { PlusOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill'
const { Option } = Select;


const SubQuestionModal = ({ modalType, setSubQuestion }) => {

    const [form] = Form.useForm();
    
    const QProps = useSelector(state => state.dailyLivingActivityR)
    const [showQuestionType, setShowQuestionType] = useState(false)
    let initialState = {
        loading: false,
        imageUrl: '',
    }

    const [photoList, setPhotoState] = useState(initialState)
    const [optionType, setOptionType] = useState('')
    const SelectQuestionType = ['Radio', 'CheckBox', 'TextArea']
    const SelectQuestionOptionType = ['With Image', 'Without Image']





    const { showSubQuestionModal, initialValues } = QProps


    const setInitialData = () => {
        console.log("========== initialValues", initialValues);
        if (initialValues) {
            setOptionType(initialValues.questionOptionType)
        }
        return () => {
            setOptionType('');
            form.setFieldsValue({ "questionLabel": "" })
        }
    }

    useEffect(setInitialData, [initialValues])

    const onFinish = (values) => {

        //
        if (values.questionOptionType === "With Image") {
            values.questionOptionImage.forEach((item, childIndex) => {
                if (item.image_optionLabel && item.image_optionLabel.file) {
                    item.image_optionLabel = item.image_optionLabel.file.response.url
                }

            })
        }
        if (values.questionOptionType === "Without Image") {
            values.questionOptionImage.forEach((item, childIndex) => {
                if (item.image_optionLabel && item.image_optionLabel.file) {
                    item.image_optionLabel = ""
                }
            })
        }
        setSubQuestion(values)

    }

    const renderGermanEditor = (type) => {
        return <ReactQuill onChange={(data) => handleChange(type, data)} />
    }
    const handleChange = (value) => {

        if (value !== 'TextArea') {
            setShowQuestionType(true)
        }
        else {
            setShowQuestionType(false)
        }
    }

    const questionOptionTypeSelected = (value) => {
        setOptionType(value)


    }
    const setFormImageUrl = (data, key) => {

        let newKey = key.join(".")
        let dataObj = photoList;
        if (data.file.status === "removed") {
            dataObj[newKey] = "";
            setPhotoState({ ...dataObj });
        } else {
            dataObj[newKey] = data;
            setPhotoState({ ...dataObj });
        }
    }


    const uploadButtonNoImageExit = (key) => {
        let newKey = key
        if (photoList && !photoList[newKey]) {
            return <div> <span className="icon icon-image gx-d-block" style={{ fontSize: '33px', opacity: '0.3' }}></span>
                <span>upload picture</span></div>
        }
    }


    const renderUploadButtonWithCondition = (imageUrl, field) => {
        let key = field.name+'.image_optionLabel';
        return imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButtonNoImageExit(key)



    }

    const renderUploadButton = (keyForImage, field) => {

       
        let newKey = field.name+".image_optionLabel";
        // console.log("======= new key", newKey)

        let imageUrl = initialValues && initialValues['questionOptionImage'] && initialValues['questionOptionImage'][field.name] && initialValues['questionOptionImage'][field.name]['image_optionLabel'];

        if (photoList && photoList[newKey] && photoList[newKey].file.status === "done") {
            imageUrl = photoList[newKey].file.response.url
        }


        return (
            <Form.Item
                name={[field.name, 'image_optionLabel']}
                fieldKey={[field.fieldKey, 'image_optionLabel']}
                rules={[{ required: true, message: 'Upload image for Option ' }]}
            >
                <Upload
                    action={`${process.env.REACT_APP_ROOT_URL}/uploadProfileImage`}
                    method="POST"
                    multiple={false}
                    showUploadList={false}
                    onChange={(data) => setFormImageUrl(data, [field.name, 'image_optionLabel'])}
                    headers={{
                        'Authorization': localStorage.getItem('token'),
                    }}
                    maxCount={1}
                    listType="picture-card"
                    accept='image/jpeg,image/jpg,image/png'
                >
                    {renderUploadButtonWithCondition(imageUrl, field)}
                </Upload>
            </Form.Item>)
    }


    const renderFormListWithImageOption = () => {
        if (optionType === "With Image") {
            return <Form.List name={'questionOptionImage'}>
                {(fields, { add, remove }) => {

                    return (
                        <>
                            {fields.map((field, index) => {
                                let keyForImage = [field.name, 'image_optionLabel'].join(".")
                                return (
                                    <Row>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Row className="">
                                                <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                                                    <span style={{
                                                        display: 'flex',
                                                        flex: 1,
                                                        height: '60%',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}>{index + 1}</span>
                                                </Col>
                                                <Col xl={5} lg={5} md={5} sm={23} xs={23}>


                                                    {renderUploadButton(keyForImage, field)}

                                                </Col>
                                                <Col xl={6} lg={6} md={6} sm={12} xs={12} className="gx-text-left">
                                                    <Form.Item
                                                        name={[field.name, 'optionLabel']}
                                                        fieldKey={[field.fieldKey, 'optionLabel']}
                                                        rules={[{ required: true, message: 'Missing Option Label' }]}
                                                    >
                                                        <Input placeholder="optionLabel" style={{ width: '100%' }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col xl={6} lg={6} md={6} sm={12} xs={12} className="gx-text-right">
                                                    <Button type="dashed" className="gx-pt-0" onClick={() => remove(field.name)}>
                                                        <span style={{ color: 'red' }}>Delete</span>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row className="gx-mr-3">
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                                    <Form.Item
                                                        className="quilEditor"
                                                        name={[field.name, 'decisionTree']}
                                                        style={{ width: "100%" }}
                                                        fieldKey={[field.fieldKey, 'decisionTree']}
                                                        initialValue={''}
                                                    >
                                                        {renderGermanEditor([field.name, 'decisionTree'])}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            })
                            }
                            <Form.Item>
                                {fields.length < 5 && <Button type="dashed" className="gx-pt-0" style={{ maxWidth: '700px' }} onClick={() => add()} block icon={<PlusOutlined />}>
                                    Add options
                            </Button>}
                            </Form.Item>
                        </>
                    )
                }}
            </Form.List>
        }
    }

    const renderFormListWithOutOption = () => {
        if (optionType === "Without Image") {
            return <Form.List name={'questionOptionImage'}>
                {(fields, { add, remove }) => {

                    return (
                        <>
                            {fields.map((field, index) => {
                                return (
                                    <Row>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Row className="">
                                                <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                                                    <span style={{
                                                        display: 'flex',
                                                        flex: 1,
                                                        height: '60%',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}>{index + 1}</span>
                                                </Col>
                                                <Col xl={16} lg={16} md={16} sm={16} xs={16} className="gx-text-left">
                                                    <Form.Item
                                                        name={[field.name, 'optionLabel']}
                                                        fieldKey={[field.fieldKey, 'optionLabel']}
                                                        rules={[{ required: true, message: 'Missing Option Label' }]}
                                                    >
                                                        <Input placeholder="optionLabel" style={{ width: '100%' }} />

                                                    </Form.Item>

                                                </Col>

                                                <Col xl={6} lg={6} md={6} sm={6} xs={6} className="gx-text-right">
                                                    <Button type="dashed" className="gx-pt-0" onClick={() => remove(field.name)}>
                                                        <span style={{ color: 'red' }}>Delete</span>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row className="gx-mr-3">
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                                    <Form.Item
                                                        className="quilEditor"
                                                        name={[field.name, 'decisionTree']}
                                                        fieldKey={[field.fieldKey, 'decisionTree']}
                                                        rules={[{ required: true, message: 'Missing decision Tree' }]}
                                                        initialValue={''}
                                                    >
                                                        {renderGermanEditor([field.name, 'decisionTree'])}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            })
                            }
                            <Form.Item>
                                {fields.length < 5 && <Button type="dashed" className="gx-pt-0" style={{ maxWidth: '700px' }} onClick={() => add()} block icon={<PlusOutlined />}>
                                    Add options
                            </Button>}
                            </Form.Item>
                        </>
                    )
                }}
            </Form.List>
        }
    }

    console.log("========= initialValues ==========", initialValues);

    return (
        <SimpleModal destroyOnClose={true} modalFor={modalType} visible={showSubQuestionModal} width={700} title={<h5 className="gx-blue-font">Sub Question</h5>}>

            <Form
                name="dynamic_form_subSuestion"
                maskClosable={false}
                onFinish={onFinish}
                autoComplete="off"
                initialValues={initialValues && { ...initialValues }}
            >

                <Row>
                    <Col xl={20} lg={20} md={20} sm={24} xs={24} >
                        <Form.Item
                            name='questionLabel'
                            rules={[{ required: true, message: 'Missing Question Label' }]}
                        >
                            <Input placeholder="Question Label" />
                        </Form.Item>
                    </Col>
                    <Col xl={20} lg={20} md={20} sm={24} xs={24} >
                        <Form.Item

                            name='questionType'
                            rules={[{ required: true, message: 'Missing Question Type' }]}
                        >
                            <Select onChange={handleChange} placeholder="Select type">
                                {SelectQuestionType.map(item => (
                                    <Option key={item} value={item}>
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>



                    </Col>

                    {showQuestionType && <Col xl={20} lg={20} md={20} sm={24} xs={24} >
                        <Form.Item
                            name='questionOptionType'
                            rules={[{ required: true, message: 'please select radio type' }]}
                        >
                            <Select onChange={questionOptionTypeSelected} placeholder="Select radio type">
                                {SelectQuestionOptionType.map(item => (
                                    <Option key={item} value={item}>
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>}
                </Row>
                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        {renderFormListWithImageOption()}
                    </Col>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        {renderFormListWithOutOption()}
                    </Col>
                </Row>
                <Row>
                    <Col xl={20} lg={20} md={20} sm={24} xs={24} className="gx-px-0">
                        <Button htmlType="submit" className="gx-mt-0 gx-pt-0">Save</Button>
                    </Col>
                </Row>

            </Form>

        </SimpleModal>
    )
}

export default SubQuestionModal
